import React, { useEffect, useMemo, useState } from "react";
import { Link } from "@quintype/components";
import { SvgIconHandler } from "../../../atoms/svg-icon-hadler";
import { shortenUrl } from "../../../../../api/utils";
import { getStoryHeadline } from "../../../utils/story";

import "./social-share-icons.m.css";

export default function SocialShareIcons({ story, imageDimension, isGnreach = false }) {
  const [shareMenuOpen, setShareMenuOpen] = useState(false);
  const [copyPopupOpen, setCopyPopupOpen] = useState(false);
  const [shortStoryUrl, setShortStoryUrl] = useState(story?.url);
  const { width, height, viewbox } = imageDimension;
  const headline = getStoryHeadline(story);

  const getShareUrl = async (name) => {
    const newUrl = await fetchShortUrl();
    let sUrl;
    switch (name) {
      case "Facebook":
        sUrl = `https://www.facebook.com/sharer.php?u=${newUrl}`;
        break;
      case "X":
        sUrl = `https://twitter.com/intent/tweet?url=${newUrl}&text=${encodeURIComponent(headline)}`;
        break;
      case "Whatsapp":
        sUrl = `https://api.whatsapp.com/send?text=${newUrl}`;
        break;
    }
    window.open(sUrl, "_blank", "noopener ,noreferrer");
  };
  const fetchShortUrl = async () => {
    try {
      const data = await shortenUrl(story?.url);
      setShortStoryUrl(data?.shortUrl);
      return data?.shortUrl;
    } catch (err) {
      console.error("Failed to shorten URL: ", err);
    }
  };
  const iconSet = useMemo(
    () => [
      {
        id: isGnreach ? "hamburger-facebook" : "share-facebook",
        label: "Facebook",
        url: `https://www.facebook.com/sharer.php?u=${shortStoryUrl}`,
      },
      {
        id: isGnreach ? "hamburger-twitter" : "share-x",
        label: "X",
        url: `https://twitter.com/intent/tweet?url=${shortStoryUrl}&text=${encodeURIComponent(headline)}`,
      },
      {
        id: isGnreach ? "hamburger-whatsapp" : "share-whatsapp",
        label: "Whatsapp",
        url: `https://api.whatsapp.com/send?text=${shortStoryUrl}`,
      },
    ],
    [shortStoryUrl]
  );

  const shareIconSet = useMemo(
    () => [
      ...iconSet,
      {
        id: isGnreach ? "share-mail-gnreach" : "share-mail",
        label: "E-mail",
        url: `mailto:?subject=${story.headline}&body=${shortStoryUrl}`,
      },
      {
        id: isGnreach ? "hamburger-linkedin" : "share-linkedin",
        label: "Linkedin",
        url: `https://www.linkedin.com/shareArticle?url=${shortStoryUrl}&title=${encodeURIComponent(headline)}`,
      },
    ],
    [iconSet, shortStoryUrl, story?.headline]
  );
  const icon = { width, height, viewBox: viewbox };

  const copyLink = isGnreach ? "share-link-gnreach" : "share-link";
  const shareMenu = isGnreach ? "share-menu-gnreach" : "share-menu";

  return (
    <span styleName="share">
      {iconSet.map((item, index) => {
        return (
          <div key={index} onClick={() => getShareUrl(item?.label)}>
            <SvgIconHandler type={item.id} height={icon.height} width={icon.width} viewBox={icon.viewBox} />
          </div>
        );
      })}
      <span
        styleName="copy-link-container"
        tabIndex={0}
        onClick={() => {
          fetchShortUrl();
          setShareMenuOpen(true);
          setTimeout(() => {
            setCopyPopupOpen(false);
          }, 3000);
          navigator.clipboard.writeText(shortStoryUrl);
        }}
      >
        <SvgIconHandler type={copyLink} height={icon.height} width={icon.width} viewBox={icon.viewBox} />
        {copyPopupOpen && <span styleName="copy-link">Link copied!</span>}
      </span>

      <span
        tabIndex={0}
        styleName="share-menu-container"
        onClick={() => {
          fetchShortUrl();
          setShareMenuOpen(true);
          setTimeout(() => {
            setShareMenuOpen(false);
          }, 5000);
        }}
      >
        <SvgIconHandler type={shareMenu} height={icon.height} width={icon.width} viewBox={icon.viewBox} />
        {shareMenuOpen && (
          <div styleName="share-menu">
            {shareIconSet.map((item, index) => {
              return (
                <Link key={index} href={item?.url} target="_blank">
                  <SvgIconHandler type={item.id} height="32px" width="32px" viewBox="0 0 32 32" />
                  <span>{item?.label}</span>
                </Link>
              );
            })}
            <div
              styleName="copy-link-container-2"
              onClick={() => {
                navigator.clipboard.writeText(shortStoryUrl);
                setCopyPopupOpen(true);
                setTimeout(() => {
                  setShareMenuOpen(false);
                  setCopyPopupOpen(false);
                }, 300);
              }}
            >
              <SvgIconHandler type={copyLink} height="32px" width="32px" viewBox="0 0 32 32" />
              <span id="copy-link">Copy link</span>
              {copyPopupOpen && <span styleName="copy-link">Link copied!</span>}
            </div>
          </div>
        )}
      </span>
    </span>
  );
}
